export enum MediaType {
  Image = "Image",
  Video = "Video",
}
